const SsdIcon = ({ ssdId, small = false }) => {
  if (!ssdId) {
    return null
  }

  const styles = small
    ? {
        display: 'inline-block',
        padding: '0px 3px',
        marginLeft: 6,
        verticalAlign: 'middle',
        border: '1px solid #505050',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '0.625rem',
        lineHeight: '1.2em',
        fontWeight: 400,
        color: '#505050',
      }
    : {
        display: 'inline-block',
        padding: '2px 5px',
        marginLeft: 10,
        verticalAlign: 'bottom',
        border: '1px solid #505050',
      }

  return (
    <span style={styles} className={small ? '' : 'cb-small-font'}>
      SSD
    </span>
  )
}

export default SsdIcon
